import { useState, useEffect, useContext, useRef } from 'react'
import ContextStates from '../context/ContextStates';
import ReactToPrint from 'react-to-print';
import { FaPrint } from 'react-icons/fa'
import axios from 'axios';
import { Url } from './Url';
import { Link } from 'react-router-dom';


const FViewJornadas = () => {
    //const [jornadaSelected, setJornada] = useState([])
    const [totalCont, setTotalCont] = useState(0)
    const [totalCuenta, setTotalCuenta] = useState(0)
    const [totalTransf, setTotalTransf] = useState(0)
    const [totalIngresos, setTotalIngresos] = useState(0)
    const [totalEgresos, setTotalEgresos] = useState(0)
    const { estadoJornada, idUsuario, jornadaSelected, setJornadaSelected, setFormView, setViewOpen, setVentaSelected, setEstadoJornada, setIdJornada, setDetalleJornada } = useContext(ContextStates)
    const componentRef = useRef();

    useEffect(() => {
        const calcTotal = () => {
            let tc = 0;
            let tcc = 0;
            let tt = 0;
            let te = 0;
            let ti = 0;
            if (typeof jornadaSelected !== 'undefined') {
                if (typeof jornadaSelected.ventas !== 'undefined') {
                    jornadaSelected.ventas.forEach(element => {
                        if (element.idmedio === '1' || element.idmedio === '5') {
                            tc = tc + parseInt(element.total);
                        }
                        else if (element.idmedio === '4') {
                            tt = tt + parseInt(element.total);
                        }
                        else if (element.idmedio === '6') {
                            tcc = tcc + parseInt(element.total);
                        }
                    });
                    setTotalCont(tc)
                    setTotalTransf(tt)
                    setTotalCuenta(tcc)
                }
                if (typeof jornadaSelected.ingresos !== 'undefined') {
                    jornadaSelected.ingresos.forEach(element => {
                        ti = ti + parseInt(element.total);
                    });
                    setTotalIngresos(ti)
                }
                if (typeof jornadaSelected.compras !== 'undefined') {
                    jornadaSelected.compras.forEach(element => {
                        te = te + parseInt(element.total);
                    });
                    setTotalEgresos(te)
                }
            }
        }
        calcTotal()
    }, [jornadaSelected])

    const closeJornada = () => {
        setFormView(51)
        setViewOpen(true)
    }

    const handleView = (item) => {
        setVentaSelected(item)
        setFormView(7)
        setViewOpen(true)
    }

    return (
        <div className='w-full justify-between' ref={componentRef}>
            <button
                type="button"
                className="p-3 ml-3 print:hidden bg-gray-500 text-white hover:bg-gray-400 transition-all uppercase font-bold rounded-lg"
                onClick={() => setDetalleJornada(false)}
            >
                Regresar a Jornadas
            </button>
            <div className="transition-all w-full mt-3">
                <h2 className='text-center text-3xl'>Jornada de Caja</h2>
                <div className="w-full rounded-lg p-5 justify-center">
                    <div className='w-full'>
                        {typeof jornadaSelected !== 'undefined' && (
                            <div className='w-full mb-10 p-5 bg-slate-50 rounded-xl'>
                                <p className='text-center text-xl'>Jornada Nº {jornadaSelected.numero}</p>
                                <p className='text-center text-xl'>Hora de Apertura: {jornadaSelected.horaapertura}</p>
                                <p className={`text-center text-xl ${parseFloat(jornadaSelected.montoinicial) > 0 && 'bg-green-200 p-3 rounded font-bold'}`}>Monto inicial de Caja: ${jornadaSelected.montoinicial}</p>
                            </div>
                        )}
                    </div>
                </div>
                <div className="w-10/12 mx-auto py-5 px-2">
                    {typeof jornadaSelected !== 'undefined' && typeof jornadaSelected.ventas !== 'undefined' && (
                        <div className='w-full'>
                            <h3 className='text-center text-2xl uppercase'>Ingresos</h3>
                            <table className='w-full mx-auto'>
                                <thead>
                                    <tr className='p-1 bg-blue-400 text-white text-center'>
                                        <th>Nº</th>
                                        <th>Fecha</th>
                                        <th>Hora</th>
                                        <th>Total</th>
                                        <th>Márgen ganancia</th>
                                        <th>Medio de Pago</th>
                                        <th className='print:hidden'>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        jornadaSelected.ventas.map((item, index) => (
                                            <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-200 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                                <td>{item.numerocomprobante}</td>
                                                <td>{item.fecha}</td>
                                                <td>{item.hora}</td>
                                                <td>$ {item.total}</td>
                                                <td>$ {item.margen}</td>
                                                <td>{item.medio}</td>
                                                <td className='text-center print:hidden'>
                                                    <button className='bg-blue-600 hover:bg-blue-400 rounded-lg py-1 px-3 text-white' onClick={() => handleView(item)}>Ver</button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    <tr className='border border-gray-300 p-2 text-center font-bold bg-green-200'>
                                        <td>Total de Contado</td>
                                        <td></td>
                                        <td></td>
                                        <td>$ {parseFloat(totalCont).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr className='border border-gray-300 p-2 text-center font-bold bg-green-200'>
                                        <td>Total con Transferencia</td>
                                        <td></td>
                                        <td></td>
                                        <td>$ {parseFloat(totalTransf).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr className='border border-gray-300 p-2 text-center font-bold bg-green-200'>
                                        <td>Total con Cuenta Corriente</td>
                                        <td></td>
                                        <td></td>
                                        <td>$ {parseFloat(totalCuenta).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
                <div className="w-10/12 mx-auto py-5 px-2">
                    {typeof jornadaSelected !== 'undefined' && typeof jornadaSelected.ingresos !== 'undefined' && (
                        <div className='w-full'>
                            <h3 className='text-center text-2xl uppercase'>Ingresos Manuales</h3>
                            <table className='w-full mx-auto'>
                                <thead>
                                    <tr className='p-1 bg-blue-400 text-white text-center'>
                                        <th>Descripción</th>
                                        <th>Fecha</th>
                                        <th>Hora</th>
                                        <th>Total</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        jornadaSelected.ingresos.map((item, index) => (
                                            <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-200 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                                <td>{item.descripcion}</td>
                                                <td>{item.fecha}</td>
                                                <td>{item.hora}</td>
                                                <td>$ {item.total}</td>
                                                <td className='text-center'>
                                                    <button className='bg-blue-600 hover:bg-blue-400 rounded-lg py-1 px-3 text-white' onClick={() => handleView(item)}>Ver</button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    <tr className='border border-gray-300 p-2 text-center font-bold bg-green-200'>
                                        <td>Total de Ingresos Manuales</td>
                                        <td></td>
                                        <td></td>
                                        <td>$ {parseFloat(totalIngresos).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
                <div className="w-10/12 mx-auto py-5 px-2">
                    {typeof jornadaSelected !== 'undefined' && typeof jornadaSelected.compras !== 'undefined' && (
                        <div className='w-full'>
                            <h3 className='text-center text-2xl uppercase'>Egresos</h3>
                            <table className='w-full mx-auto'>
                                <thead>
                                    <tr className='p-1 bg-blue-400 text-white text-center'>
                                        <th>Fecha</th>
                                        <th>Hora</th>
                                        <th>Total</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        jornadaSelected.compras.map((item, index) => (
                                            <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-200 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                                <td>{item.fecha}</td>
                                                <td>{item.hora}</td>
                                                <td>$ {item.total}</td>
                                                <td className='text-center'>
                                                    <button className='bg-blue-600 hover:bg-blue-400 rounded-lg py-1 px-3 text-white' onClick={() => handleView(item)}>Ver</button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    <tr className='border border-gray-300 p-2 text-center font-bold bg-orange-200'>
                                        <td>Total de Egresos</td>
                                        <td></td>
                                        <td>$ {parseFloat(totalEgresos).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
                {/*totalEgresos > 0 && (
                    <div className='w-10/12 mx-auto my-10'>
                        <p className='text-center text-2xl font-bold uppercase text-gray-800 p-3 rounded bg-blue-200'>Saldo Neto $ {(parseFloat(jornadaSelected.montoinicial) + parseFloat(totalCont) - parseFloat(totalEgresos)).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                        <p className='text-center'>(Monto inicial de Caja + Total en Efectivo - Egresos)</p>

                    </div>
                )*/}
            </div>
            <ReactToPrint
                trigger={() =>
                    <p
                        className="print:hidden w-1/3 hover:cursor-pointer sm:w-1/4 flex shadow-md p-3 mt-10 ml-3 bg-indigo-500 text-white hover:bg-indigo-400 transition-all uppercase font-bold rounded-lg"
                    >
                        <FaPrint className='mx-auto mt-1' />
                        <span className='mx-auto text-center'>
                            Imprimir Listado
                        </span>
                    </p>}
                content={() => componentRef.current}
            />
            <div className="w-full rounded-lg px-3 flex justify-center mt-10">
                <button
                    type="button"
                    className="p-3 ml-3 print:hidden bg-gray-500 text-white hover:bg-gray-400 transition-all uppercase font-bold rounded-lg"
                    onClick={() => setDetalleJornada(false)}
                >
                    Regresar a Jornadas
                </button>
            </div>
        </div>
    )
}

export default FViewJornadas